import Footer from "../../components/common/Footer/Footer";
import Header from "../../components/common/Header/Header";
import ContactUs from "../../components/common/ContactUs/ContactUs";
import CustomImage from "../../components/core/CustomImage/CustomImage";
import useIsMobile from "../../components/hooks/useIsMobile";
import classes from "../../styles/AboutUs.module.scss";
import classnames from "classnames";
import { nanoid } from "nanoid";
import banner_au from "../../assets/images/banner_au.png";
import banner02_au from "../../assets/images/banner02_au.png";
import banner03_au from "../../assets/images/banner03_au.png";
import whoweare from "../../assets/images/whoweare.png";
import rocket from "../../assets/images/rocket.png";
import servingImg from "../../assets/images/serving.png";
import growth from "../../assets/images/growth.png";
import Tab from "../../components/core/Tab/Tab";

import { yearsGrowthdata, servingdata } from "../../global/constant";
import { useState } from "react";

function AboutUs() {
  const isMobile = useIsMobile({ breakpoint: 768 });
  const style = {
    bannerContainer: {
      display: "flex",
      flexDirection: isMobile ? "column-reverse" : "row",
      gap: 20,
      paddingTop: 20,
    },
  };
  return (
    <>
      <Header page="aboutus" />
      <div className={classnames(classes.container, "minheightCont100vh")}>
        <div style={{ backgroundColor: "#F1F5F9" }}>
          <div
            className={classnames("containerWidth")}
            style={style.bannerContainer}
          >
            <div style={{ flex: 1, alignSelf: "center" }}>
              <div
                className={classnames("heading")}
                style={{ textAlign: "left" }}
              >
                Build digital success stories with us.
              </div>
              <div
                className={classnames("subheading")}
                style={{
                  textAlign: "left",
                  margin: "unset",
                  paddingBottom: "20px",
                }}
              >
                Partnering with Paytm Cloud Solutions to boost businesses as it
                is an all-in-one telephony and digital solution that help
                medium-sized businesses build and manage successful digital
                stories
              </div>
            </div>
            <div
              style={{
                flex: 1,
                position: "relative",
                background: `url(${banner_au}) no-repeat center bottom / contain`,
                display: "flex",
              }}
            >
              <CustomImage
                src={banner02_au}
                className={classnames(classes.aboutusBannerImg)}
                width="75%"
              />
              <CustomImage
                src={banner03_au}
                className={classnames(
                  classes.aboutusBannerImg,
                  classes.banner03_au
                )}
                width="100%"
              />
            </div>
          </div>
        </div>
        <div
          className={classnames("containerWidth")}
          style={{ marginBottom: 40 }}
        >
          <div>
            <div className={classnames(classes.heading, "heading")}>
              Who we are
            </div>
            <CustomImage
              src={whoweare}
              style={{ paddingBottom: 24, maxWidth: 610 }}
              width="100%"
            />
            <div className={classnames("subheading")}>
              Our dedicated team of developers, marketers, designers, and
              technical support experts are passionate about helping SMBs
              operate and grow their Businesses
            </div>
          </div>
          <div>
            <CustomImage
              src={rocket}
              style={{ paddingTop: 40, maxWidth: 120 }}
              width="100%"
            />
            <div
              className={classnames(classes.heading, "heading")}
              style={{ paddingTop: 10 }}
            >
              A Mission to accelerate Success
            </div>
            <div className={classnames("subheading")}>
              Our core focus is building fast, flexible, and reliable digital
              commerce. We are committed to providing tools and services that
              empower SMBs to rapidly and efficiently gain awareness, drive
              revenue, and manage all aspects of digital commerce. We achieve
              this by cultivating a team of adaptable, collaborative, effective,
              founder-focused, humble, and transparent experts who focus on
              solving for the customer.
            </div>
          </div>
          <div>
            <CustomImage
              src={servingImg}
              style={{ paddingTop: 80, maxWidth: 64 }}
              width="100%"
            />
            <div
              className={classnames(classes.heading, "heading")}
              style={{ paddingTop: 10 }}
            >
              Serving Businesses of all shapes & sizes
            </div>
            <div className={classnames("subheading")}>
              Our customers are a mixture of individuals and organisations with
              dreams of managing successful online businesses.
            </div>
            <div
              className={classnames(classes.flex_box, classes.seving_flex)}
              style={{
                gap: 0,
                justifyContent: "center",
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              {servingdata.map(data => {
                return (
                  <div className={classnames(classes.block)} key={nanoid()}>
                    <div
                      className={classnames("heading", classes.serviceData)}
                      style={{
                        whiteSpace: "nowrap",
                        margin: 0,
                      }}
                    >
                      {data.value}
                    </div>
                    <div className={classnames("subheading")}>{data.type}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <div>
            <CustomImage
              src={growth}
              style={{ paddingTop: 40, maxWidth: 64 }}
              width="100%"
            />
            <div
              className={classnames(classes.heading, "heading")}
              style={{ paddingTop: 10 }}
            >
              Over two decades of learning & growth
            </div>
            <div className={classnames("subheading")}>
              Paytm Cloud has been helping businesses for every twenty years.
              Check out our timeline to learn more about our journey and where
              we are going as a company.
            </div>
            <div style={{ marginTop: "30px", marginBottom: "80px" }}>
              <GrowthYears />
            </div>
          </div>
        </div>
        <ContactUs />
        <Footer />
      </div>
    </>
  );
}

const GrowthYears = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = yearsGrowthdata.map(item => ({
    title: item.year,
    content: (
      <TabContent
        title={String(item.year)}
        points={item.points}
        setActiveTab={setActiveTab}
      />
    ),
  }));
  return (
    <>
      <Tab tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
    </>
  );
};

const TabContent = ({ title, points = [], setActiveTab }) => {
  const years = yearsGrowthdata.map(item => item.year);
  const findTabIndexByTitle = e => {
    let value = parseInt(e.target.getAttribute("value"));
    let index = years.findIndex(tab => {
      return tab === value;
    });
    setActiveTab(index); // Set the active tab index
  };
  return (
    <div className={classes.tabContentContainer}>
      {years.map(year => {
        return year.toString() === title.toString() ? (
          <div className={classes.tabactivecontainer} key={nanoid()}>
            <div className={classes.year}>{title}</div>
            <ul>
              {points.map(point => {
                return <li key={nanoid()}>{point}</li>;
              })}
            </ul>
          </div>
        ) : (
          <div
            className={classes.year}
            style={{ color: "#E2E8F0" }}
            key={nanoid()}
            value={year}
            onClick={e => {
              findTabIndexByTitle(e);
            }}
          >
            {year}
          </div>
        );
      })}
    </div>
  );
};

export default AboutUs;
